import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppLoadingService } from '../../../features/auth/services/app-loading.service';

@Component({
  selector: 'app-loading-component',
  standalone: true,
  imports: [MatProgressSpinnerModule, AsyncPipe],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  loading = inject(AppLoadingService);
  message$ = this.loading.message$;
}
